import { RefObject } from 'react';
import CartConflictModal from '@components/organisms/CartConflictModal/CartConflictModal';
import MergeCartModal from '@components/organisms/MergeCartModal/MergeCartModal';
import CartPreview from '@molecules/MiniCart/Preview/CartPreview';
import { selectConflictingModal } from '@slices/conflictingModalSlice';
import { useAppSelector } from '@hooks/useAppDispatch';
import useMergeCartModalWillShow from '@hooks/useMergeCartModalWillShow';

interface Props {
  headerRef: RefObject<HTMLDivElement | null>;
}

const CartModals = ({ headerRef }: Props) => {
  const conflictingModal = useAppSelector(selectConflictingModal);
  const mergeCartModalWillShow = useMergeCartModalWillShow();

  return (
    <>
      {conflictingModal.open && <CartConflictModal />}
      {mergeCartModalWillShow && <MergeCartModal />}
      <CartPreview headerRef={headerRef} />
    </>
  );
};

export default CartModals;
